const AllLogs = () => import("./views/AllLogs.vue");
const ClockLogSettings = () => import("./views/ClockLogSettings.vue");
const Location = () => import("./views/Location.vue");
const LocationForm = () => import("./views/LocationForm.vue");
// const AllApprovers = () => import("./views/AllApprovers.vue");
// const AssignEmployeesAsApprovers = () =>
//   import("./components/AssignEmployeesAsApprovers.vue");
// const ViewApprovers = () => import("./views/ViewApprovers.vue");
// const CreateApprover = () => import("./views/CreateApproval.vue");

const AllApprovers = () =>
  import("@/components/general/approvals/AllApprovers.vue");
const AssignEmployeesAsApprovers = () =>
  import("@/components/general/approvals/AssignEmployeeToApprover.vue");
const ViewApprovers = () =>
  import("@/components/general/approvals/ViewApprovers.vue");
const CreateApprover = () =>
  import("@/components/general/approvals/CreateApprovers.vue");
import approverProps from "@/components/general/approvals/ApproverProps.js";
const { mobileClocks } = approverProps;
// const
export default [
  {
    path: "all-logs",
    component: AllLogs,
  },
  {
    path: "settings",
    component: ClockLogSettings,
  },
  {
    path: "settings/location",
    component: Location,
  },
  {
    path: "settings/location/create",
    component: LocationForm,
  },
  {
    path: "settings/location/edit/:id",
    component: LocationForm,
  },
  {
    path: "settings/approvers",
    component: AllApprovers,
    props: mobileClocks,
  },
  {
    path: "settings/approvers/assign/:id",
    component: AssignEmployeesAsApprovers,
    props: mobileClocks,
  },
  {
    path: "settings/approvers/edit/:id",
    component: CreateApprover,
    props: mobileClocks,
  },
  {
    path: "settings/approvers/view/:id",
    component: ViewApprovers,
    props: mobileClocks,
  },
  {
    path: "settings/approvers/create",
    component: CreateApprover,
    props: mobileClocks,
  },
];
